<div class="form-group-block">
    <div class="form-group mb-0">
        <label id="q-f-label">Please provide your comments for question {{questionNumber}}</label>
        <textarea [(ngModel)]="feedback" class="form-control" placeholder="Enter feedback" [style.height.px]="textareaHeight"></textarea>
    </div>
</div>
